/*
 * Copyright © 2019 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import IDirective = angular.IDirective;
import IDirectiveFactory = angular.IDirectiveFactory;

let template = require('./dv-pagination.html');

export class DvPagination implements IDirective {
    restrict = 'E';
    template = template;

    link = (scope: any, element: any, attrs: any) => {
        scope.$watch('currentPage', function (c: any) {
            scope.inputPage = c;
        });
        scope.$watch('inputPage', (c: any) => {
            if (scope.inputPage > scope.numPages) {
                scope.inputPage = scope.numPages;
                if (scope.currentPage !== scope.numPages) {
                    scope.selectPage(scope.numPages);
                }
            }
            if (scope.inputPage < 1) {
                scope.inputPage = 1;
                if (scope.currentPage !== 1) {
                    scope.selectPage(1);
                }

            }
        });

    };

    static factory(): IDirectiveFactory {
        const directive = () => new DvPagination();
        directive.$inject = [];
        return directive;
    }
}




// WEBPACK FOOTER //
// ./src/app/core/directive/dv-pagination/dv-pagination.ts